/*
地图调度模块路由
2018-1-24
 */
"use strict";
angular.module("mapSchedulingRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider
        .state("front.planningresource.commandMonitor.mapscheduling", {
            url: "/mapscheduling",
            views: {
                "main@front.planningresource.commandMonitor": {
                    template: "<div ui-view='main' class='content_text_wrap' trs-height></div>"
                }
            }
        })
        .state("front.planningresource.commandMonitor.mapscheduling.manage", {
            url: "/manage",
            views: {
                "main@front.planningresource.commandMonitor.mapscheduling": {
                    templateUrl: "./planningResource/commandMonitor/mapScheduling/manage/manage_tpl.html",
                    controller: "mapSchedulingManageCtrl"
                }
            }
        });
}]);